import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SideBarArrow from '../img/SideBarArrow.svg';
import SideBarArrowComponent from '../img/SidebarArrow';
import AddUserModal from './AddUserModal';
import AddPartnerModal from './AddPartnerModal';
import ChangePartnerView from './ChangePartnerView';
import ChangeUserRole from './ChangeUserRole';
import AnalyticsButton from './AnalyticsButton';
import DownloadUsersButton from './DownloadUsersButton';

const AdminButtons = ({ setWazuhPanel, open, closeAllSubmenus, navigate }) => {
  const [submenu, setSubmenu] = useState(false);
  const [openModalName, setOpenModalName] = useState(null);

  const handleSubMenu = () => {
    // Navigate to default path when opening Wazuh Panel
    if (submenu === false && navigate) {
      navigate('/wazuh-analytics');
    }
    setWazuhPanel(!open);
    setSubmenu(!submenu);
    // Close other sidebar menus when opening Wazuh Panel
    if (!submenu && closeAllSubmenus) {
      closeAllSubmenus();
    }
  };

  const handleModalOpen = (modalName) => {
    setOpenModalName(modalName);
  };

  const handleModalClose = () => {
    setOpenModalName(null);
  };

  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname !== '/wazuh-analytics') {
      setSubmenu(false);
    }
  }, [pathname]);

  return (
    <div>
      <button
        onClick={handleSubMenu}
        className={`flex dark:text-white pl-8  font-normal hover:text-blue-500 py-2 border-l-[2px] border-[#EAEAEA] justify-between w-[85%] ${
          submenu && 'bg-mainblue w-[85%] rounded-r-xl'
        }`}
      >
        {submenu ? (
          <div className='font-bold flex text-white'>
            <img
              alt='blue-arrow'
              className='relative right-[14px] w-1'
              src={SideBarArrow}
            />
            <span className='relative right-1'>Wazuh Panel</span>
          </div>
        ) : (
          <div>Wazuh Panel</div>
        )}

        <SideBarArrowComponent
          className={`ml-2 mt-1 transition ease-out duration-300 mr-7 w-[11px] h-[18px] ${
            submenu ? 'rotate-180 text-white' : 'text-mainblack dark:text-white'
          }`}
        />
      </button>
      <div className='pl-[19px]'>
        <div
          className={`${
            !submenu && 'hidden'
          }  mt-4 pl-[35.5px] border-l-[2.8px] border-[#EAEAEA]`}
        >
          <AddUserModal
            closeAllSubmenus={closeAllSubmenus}
            onModalOpen={() => handleModalOpen('addUser')}
            onModalClose={handleModalClose}
            isActive={openModalName === 'addUser'}
          />
          <AddPartnerModal
            closeAllSubmenus={closeAllSubmenus}
            onModalOpen={() => handleModalOpen('addPartner')}
            onModalClose={handleModalClose}
            isActive={openModalName === 'addPartner'}
          />
          <ChangePartnerView
            closeAllSubmenus={closeAllSubmenus}
            onModalOpen={() => handleModalOpen('changePartnerView')}
            onModalClose={handleModalClose}
            isActive={openModalName === 'changePartnerView'}
          />
          <ChangeUserRole
            closeAllSubmenus={closeAllSubmenus}
            onModalOpen={() => handleModalOpen('changeUserRole')}
            onModalClose={handleModalClose}
            isActive={openModalName === 'changeUserRole'}
          />
          <AnalyticsButton
            closeAllSubmenus={closeAllSubmenus}
            isAnyModalOpen={openModalName !== null}
          />
          <DownloadUsersButton />
        </div>
      </div>
    </div>
  );
};

export default AdminButtons;
